export const alarmLevelIds = {
    Emergency: 'b40de057-8e4a-435e-af0e-51c9bbd2534c',//紧急
    Normal: 'f2c328b0-9882-4c40-9b88-1660f012b010',//一般
}